import { useContext, useEffect, useCallback } from 'react'
import { SignalrContext } from '@/components/signalrProvider'
// import debug from 'debug'

// const log = debug('app:useSocket')

export function useSignalR (
  methodName,
  callback,
  deps
) {
  const connection = useContext(SignalrContext)
  const cb = useCallback(callback, deps)

  useEffect(() => {
    if (connection) {
      connection.on(methodName, cb)
    }

    return () => {
      if (connection) {
        connection.off(methodName, cb)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [connection, cb])
}



// WEBPACK FOOTER //
// ./src/hooks/useSignalR.js